"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var proxyApi_1 = require("../constants/proxyApi");
var browserStorage_1 = require("../utils/browserStorage");
// Create a fetch-based HTTP client with axios-compatible interface
var createHttpClient = function () {
    var fetchWrapper = function (url, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(void 0, void 0, void 0, function () {
            var response, data, headers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(url, __assign(__assign({}, options), { headers: __assign({ 'Content-Type': 'application/json' }, options.headers) }))];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json().catch(function () { return null; })];
                    case 2:
                        data = _a.sent();
                        headers = {};
                        response.headers.forEach(function (value, key) {
                            headers[key] = value;
                        });
                        // Return axios-compatible response
                        return [2 /*return*/, {
                                data: data,
                                status: response.status,
                                statusText: response.statusText,
                                headers: headers,
                                config: options,
                                request: {},
                            }];
                }
            });
        });
    };
    return {
        get: function (url, config) { return fetchWrapper(url, __assign({ method: 'GET' }, config)); },
        post: function (url, data, config) { return fetchWrapper(url, __assign({ method: 'POST', body: JSON.stringify(data) }, config)); },
        put: function (url, data, config) { return fetchWrapper(url, __assign({ method: 'PUT', body: JSON.stringify(data) }, config)); },
        patch: function (url, data, config) { return fetchWrapper(url, __assign({ method: 'PATCH', body: JSON.stringify(data) }, config)); },
        delete: function (url, config) { return fetchWrapper(url, __assign({ method: 'DELETE' }, config)); },
    };
};
var httpClient = createHttpClient();
var baseURL = proxyApi_1.BASE_URL;
/**
 * HTTP request wrapper for proxy api.
 * @param config Partial<AxiosRequestConfig>
 * @returns Promise<AxiosResponse<T>>
 */
var doRequest = function (config) {
    var _a;
    var method = ((_a = config === null || config === void 0 ? void 0 : config.method) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || 'get';
    var url = (config === null || config === void 0 ? void 0 : config.url) || '';
    var fullUrl = baseURL ? "".concat(baseURL, "/").concat(url).replace(/\/+/g, '/').replace(/:\//g, '://') : url;
    // Create config for the HTTP client
    var requestConfig = __assign(__assign({}, config), { headers: (config === null || config === void 0 ? void 0 : config.headers) || {} });
    switch (method) {
        case 'post':
            return httpClient.post(fullUrl, config === null || config === void 0 ? void 0 : config.data, requestConfig);
        case 'put':
            return httpClient.put(fullUrl, config === null || config === void 0 ? void 0 : config.data, requestConfig);
        case 'patch':
            return httpClient.patch(fullUrl, config === null || config === void 0 ? void 0 : config.data, requestConfig);
        case 'delete':
            return httpClient.delete(fullUrl, requestConfig);
        case 'get':
        default:
            return httpClient.get(fullUrl, requestConfig);
    }
};
/**
 * open request to non-protected endpoint.
 * @param config Partial<AxiosRequestConfig>
 * @returns Promise<AxiosResponse<T>>
 */
var request = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, result;
    return __generator(this, function (_a) {
        headers = (config === null || config === void 0 ? void 0 : config.headers) ? config.headers : {};
        result = doRequest(__assign(__assign({}, config), { headers: __assign({}, headers) }));
        return [2 /*return*/, result];
    });
}); };
/**
 * request from logged in user to protected endpoint.
 * @param config Partial<AxiosRequestConfig>
 * @returns Promise<AxiosResponse<T>>
 */
var protectedRequest = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, isCiamflow, tokenResponse, ciamToken, result, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                headers = (config === null || config === void 0 ? void 0 : config.headers) ? config.headers : {};
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                isCiamflow = Boolean(window.msalInstance);
                tokenResponse = void 0;
                if (!isCiamflow) return [3 /*break*/, 2];
                ciamToken = localStorage.getItem('CIAM.TOKEN');
                if (!ciamToken) {
                    throw new Error('No CIAM token found in localStorage');
                }
                tokenResponse = { bearerToken: ciamToken };
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, (0, browserStorage_1.getTokenResponse)()];
            case 3:
                tokenResponse = _a.sent();
                _a.label = 4;
            case 4:
                result = doRequest(__assign(__assign({}, config), { headers: __assign(__assign({}, headers), { Authorization: "Bearer ".concat(tokenResponse.bearerToken) }) }));
                return [2 /*return*/, result];
            case 5:
                e_1 = _a.sent();
                return [2 /*return*/, Promise.reject(e_1)];
            case 6: return [2 /*return*/];
        }
    });
}); };
var proxyApi = {
    request: request,
    protectedRequest: protectedRequest,
};
exports.default = proxyApi;
